import { gql } from 'graphql-request'

class ExperienceQueries {
  getAll = gql`
    query getExperiences(
      $where: ExperienceWhereInput
      $first: Int
      $skip: Int
      $orderBy: ExperienceExtendedOrderByInput
    ) {
      experiences(where: $where, first: $first, skip: $skip, orderBy: $orderBy) {
        id
        title
        text
        isValidated
        isVerified
        evaluation
        createdAt
        author {
          user {
            displayName
          }
        }
        place {
          name
          address
          customer {
            name
          }
          location {
            city
          }
        }
      }
    }
  `
  getSingle = gql`
    query getExperience($where: ExperienceWhereUniqueInput!) {
      experience(where: $where) {
        id
        title
        text
        isValidated
        isVerified
        evaluation
        createdAt
        author {
          user {
            displayName
          }
        }
        place {
          name
          address
          customer {
            name
          }
          location {
            city
          }
        }
        images {
          id
          altText
          reference
          url
        }
        reply {
          text
          author {
            user {
              displayName
            }
          }
        }
      }
    }
  `
}

const experienceQueries = new ExperienceQueries()

export default experienceQueries
